import {NgModule} from '@angular/core'
import {RouterModule, Routes} from '@angular/router'
import {ArticlePageComponent} from './article-page/article-page.component'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {ArticleLanguageUnavailablePageComponent} from './article-language-unavailable-page/article-language-unavailable-page.component'
import {ArticleResolver} from './article-page/article.resolver'
import {ArticleLanguageUnavailableResolver} from './article-language-unavailable-page/article-language-unavailable.resolver'
import {ArticleOverviewPageComponent} from './article-overview-page/article-overview-page.component'
import {TopicOverviewPageComponent} from './topic-overview-page/topic-overview-page.component'
import {TopicOverviewResolver} from './topic-overview-page/topic-overview.resolver'

export const routes: Routes = [
  {
    path: PUBLIC_ROUTES.ARTICLE_OVERVIEW.routingPath,
    component: ArticleOverviewPageComponent,
  },
  {
    path: PUBLIC_ROUTES.TOPIC_OVERVIEW_PAGE.routingPath,
    component: TopicOverviewPageComponent,
    resolve: {
      content: TopicOverviewResolver,
    },
  },
  {
    path: PUBLIC_ROUTES.ARTICLE_PAGE_UNAVAILABLE.routingPath,
    component: ArticleLanguageUnavailablePageComponent,
    resolve: {
      availability: ArticleLanguageUnavailableResolver,
    },
  },
  {
    path: PUBLIC_ROUTES.ARTICLE_PAGE.routingPath,
    component: ArticlePageComponent,
    data: {shouldReuse: false},
    resolve: {
      content: ArticleResolver,
    },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArticleRoutingModule {}
